import "./Content.css";

const Content = () => {
  return (
    <div className="content">
      <div className="content__segment">
        <h2>What is Email Signature Generator?</h2>
        <p>
          It is an online tool that helps you generate custom email signatures to represent your brand and sign off all emails that you send. SEOHorizon’s free email signature generator has several templates and readymade designs to choose one for your signature. You can also upload your brand’s logo to create a unique signature for your emails. Last but not least, you can also add social media links, call to actions to your signature for ready reference. 
        </p>
      </div>

      <div className="content__segment">
        <h2>How to use SEO Horizon's Email Signature Generator?</h2>
        <p>
          First of all, you have to fill in all the required details (the ones you deem necessary) under the Main, Social, Style, and CTA tabs. While in the ‘Main’ tab you can give primary details, like name, contact, addresses, websites, etc., the Social tab will allow you to add links to your social media profiles that you wish to show in your signature. The CTA tab enables you to add a strong Call-To-Action message to the emails for increasing brand visibility. 
        </p>
        <p>
          Under the ‘Style’ tab, you can customize your signature in whatever way you think will enhance the overall effect. You can pick themes, colors, font styles, and shades from the library to create a bespoke email signature. Once you are put in the CTA text, you can now click on the ‘Create Signature’ button to generate a custom email signature. That’s it! Easy-peasy! Now, all you have to do is copy the signature to your email or simply copy the source code, whichever is more convenient. 
        </p>
      </div>

      <div className="content__segment">
        <h2>Why Does Your Business Need an Email Signature?</h2>
        <p>
          Very few businesses are left that do not need to send emails to their clients/customers regularly. A professional email signature that includes your brand logo, name, website, and all other significant details, will not only enhance your business impression but also promote your brand. The recipient may click on the website link to check your authenticity or visit your social media handles to get an idea of your brand value. It will help generate more traffic for your website, as well as increase the chances of social media growth. Besides, an email with a professional signature has more chances of getting a response than one without. 
        </p>
      </div>

      <div className="content__segment">
        <h2>What are the Benefits of our Email Signature Generator?</h2>
        <p>
          At SEO Horizon, our free email signature generator can help you create and grow your brand identity besides generating more leads for your business. To sum up, it offers the following benefits:
        </p>
        <div className="div-p">
					<ul>
						<li><b>Stay professional - </b>An email ending with a well-formulated signature looks professional and quite cleaned up. </li>
            <li><b>Increased chances of response - </b>Emails with professional signatures enjoy more chances of responses than the ones without. </li>
            <li><b>More leads - </b>If you integrate the links of your social media handles in the signature, the chances of generating more leads increase invariably.  </li>
            <li><b>More clicks - </b>Including your website link in your email signature helps it get clicked more, thus increasing your brand exposure.  </li>
					</ul>
				</div>
      </div>

      <div className="content__segment">
        <h2>What are the Key Features of our Email Signature Generator?</h2>
        <p>
          The following are the main features of SEO Horizon’s html email signature generator:
        </p>
        <div className="div-p">
					<ul>
						<li><b>Create a signature in a minute - </b>You can create the email signature within 60 seconds if you have all the information ready in hand.</li>
            <li><b>Multiple social media links - </b>It does not matter which social media platforms do you prefer to use for your business, as we have dozens of buttons to add to your email signature. Pick the ones you think should go with the emails you send. </li>
            <li><b>Several design templates - </b>You can customize your email signature using the several readymade templates on our email signature generator.</li>
            <li><b>Compatible with major email vendors - </b>Gmail, Apple Mail, Outlook, and you name it! Our email signatures are compatible with all.</li>
            <li><b>24X7 Support - </b>You can resolve your queries anytime throughout the week, as we provide a 24X7 query-resolution base for the same.</li>
					</ul>
				</div>
      </div>

    </div>
  );
};

export default Content;
